module.exports = __webpack_public_path__ + "static/img/athome2.9000ef1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/athome2.jpeg
// module id = 179
// module chunks = 1